export default __webpack_public_path__ + "static/media/sp-2.c8b252fc.png";